import React, { lazy } from 'react';
import { scrollToOffer } from '../utils/scroll';
const RECIPES = [{
  img: 'https://cdn.magicpatterns.com/uploads/5g6Argiwzj3xMiFVGT3hn1/ChatGPT_Image_17_mar_2026,_10_54_18.png',
  label: 'Plumcake al Limone Glassato',
  emoji: '🍋'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/chL7FYKr9PrVZ1zUTVAydA/ChatGPT_Image_17_mar_2026,_10_57_33.png',
  label: 'Plumcake al Cioccolato Fondente',
  emoji: '🍫'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/pS1xLNu3vvsvxaDyALasPn/ChatGPT_Image_17_mar_2026,_10_56_06.png',
  label: 'Plumcake Marmorizzato',
  emoji: '🌀'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/1Tyf3zTcuCfpMM5wEb4hLj/ChatGPT_Image_17_mar_2026,_10_59_46.png',
  label: 'Plumcake alle Gocce di Cioccolato',
  emoji: '✨'
}];
export function RecipeGallery() {
  return <section className="py-16 px-4 bg-amber-50" data-id="element-254">
      <div className="max-w-5xl mx-auto" data-id="element-255">
        <div className="text-center mb-10" data-id="element-256">
          <p className="text-sm font-bold uppercase tracking-widest text-amber-600 mb-3" data-id="element-257">
            I tuoi prossimi capolavori
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-258">
            Ecco cosa preparerai con questo libro
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-259">
            Ricette soffici, umide e irresistibili che sorprenderanno la tua
            famiglia e i tuoi ospiti.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10" data-id="element-260">
          {RECIPES.map((recipe, idx) => <div key={idx} className="group relative rounded-2xl overflow-hidden shadow-md aspect-square cursor-pointer" onClick={scrollToOffer} data-id="element-261">
              <img src={recipe.img} alt={recipe.label} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" data-id="element-262" />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" data-id="element-263" />
              {/* Label */}
              <div className="absolute bottom-0 left-0 right-0 p-3" data-id="element-264">
                <p className="text-white font-bold text-xs md:text-sm leading-tight drop-shadow-lg" data-id="element-265">
                  {recipe.emoji} {recipe.label}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-266">
          <button onClick={scrollToOffer} className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-4 px-8 rounded-full shadow-lg transition-all transform hover:scale-105 text-lg" data-id="element-267">
            Voglio imparare a prepararli →
          </button>
        </div>
      </div>
    </section>;
}